const genActionTypes = {
  SET_CONNECTOR: 'SET_CONNECTOR',
  SET_ACCOUNT: 'SET_ACCOUNT',
  SET_CLIPBOARD: 'SET_CLIPBOARD',
}

export default genActionTypes;